/**
* *************************************************************************
*  ADOBE CONFIDENTIAL
*  ___________________
* 
*   Copyright 2017 Adobe
*   All Rights Reserved.
* 
*  NOTICE:  All information contained herein is, and remains
*  the property of Adobe and its suppliers, if any. The intellectual
*  and technical concepts contained herein are proprietary to Adobe
*  and its suppliers and are protected by all applicable intellectual
*  property laws, including trade secret and copyright laws.
*  Dissemination of this information or reproduction of this material
*  is strictly forbidden unless prior written permission is obtained
*  from Adobe.
* **************************************************************************
* 
**/'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * FormattedMessage functional formatter component
 * @param {object} provider the reference to the provider for i18n
 * @param {string} messageId The message id to find in the dictionary
 * @param {object} values key value pairs with properties to replace the tokens
 * @param {string} defaultMessage The templated string to be formatted
 * @param {function} customInterpolator a custom interpolator function to parse the strings
 * @return {string} formatted and localized string
 * @constructor
 */
function FormattedMessage(provider, _ref) {
  var messageId = _ref.messageId,
      values = _ref.values,
      _ref$defaultMessage = _ref.defaultMessage,
      defaultMessage = _ref$defaultMessage === undefined ? 'no default message string was provided' : _ref$defaultMessage,
      customInterpolator = _ref.customInterpolator;
  var _provider$state = provider.state,
      locale = _provider$state.locale,
      interpolator = _provider$state.interpolator;

  var messageValue = provider.getMessage(messageId) || defaultMessage;

  if (!customInterpolator && typeof customInterpolator !== 'function') {
    return interpolator(messageValue, values, locale);
  }
  return customInterpolator(messageValue, values, locale);
}

FormattedMessage.displayName = 'i18nFormattedMessage';

exports.default = FormattedMessage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@exc-ui/exc-sdk/dist/production/localization/formatters/FormattedMessage.js
// module id = 707
// module chunks = 0